<template>
<div>


    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

<div class="card text-black mb-1 mt-1" >
<div  class="card-header bg-light">
    <h4><i class="far fa-file-pdf mr-2 bold" aria-hidden="true"></i>NUOVO DOCUMENTO DI ACQUISTO (FATTURA/DDT)</h4>
    
<div class="col-md-6 col-lg-5">


<form @submit.prevent="submit">

  <collectionSelect
    :props="collection"
    @update="setCollectionId">
  </collectionSelect>

  <div class="d-flex flex-wrap align-items-end">

    <div class="form-group mr-4">
      <label for="number_doc"><strong>NUMERO DOCUMENTO</strong></label>
      <input
        v-focus
        v-model="document.number"
        type="text"
        class="form-control"
        id="number_doc"
        required>
    </div>

    <div class="form-group mr-4">
      <label for="date_doc"><strong>DATA DOCUMENTO</strong></label>
      <input
        v-model="document.date"
        type="date"
        class="form-control"
        id="date_doc"
        required>
    </div>

    <div class="form-group">
      <label for="doc_type"><strong>TIPO DOCUMENTO</strong></label>
      <select
        v-model="document.typeId"
        class="form-control"
        id="doc_type"
        required>
        <option value="1">Fattura</option>
        <option value="2">DDT</option>
      </select>
    </div>

  </div>

  <div class="d-flex justify-content-between mt-3">
    <button
      type="button"
      @click="$emit('close')"
      class="btn btn-secondary">
      <i class="fas fa-reply mr-2 text-warning"></i>
      RITORNA A CONSEGNA
    </button>

    <button
      type="submit"
      class="btn btn-primary">
      <i class="fas fa-save mr-2 text-warning"></i>
      SALVA
    </button>
  </div>

</form>


</div>

</div>
</div>

<!-- MAIN DIV -->
</div>

</template>
<script>

import api                         from '@/api'
import collectionSelect            from '@/components/common/CollectionSelect_1.vue' 
import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'
import { mapGetters }              from 'vuex'


export default {
  
  components: {collectionSelect,modalConfirm,modalMessage
  
  },  
  props: ['order'],

  data () {
    return {
      
      document  : {},
      collection           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        

      },
      
    }
  },
computed: 
{
  ...mapGetters(['company']),
},
 directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()
          el.select()
          }
       
      }
    },
created()
{ 

    this.collection.Id = this.order.collectionId
      
},

methods:
{

  setCollectionId(Id)
    { 
      this.collection.Id = Id
      
    },
async submit() 
  {

       const confirmed=  await this.$refs.confirmModal.show(
          'SI DESIDERA REGISTRARE IL DOCUMENTO ?',
          { title: 'CONFERMA ' },1
        )

        if (!confirmed) return  
        this.$refs.confirmModal.close()

    const collectionId = this.collection.Id   
    const supplierId   = this.order.supplierId    
    const storeId      = this.order.storeId
    const sp           = 'spCreateSupplierStockMovementDocument'
    const payload      = {'companyId'   : this.company.Id ,
                   ...this.document, 
                   storeId,
                   supplierId,
                   collectionId,
                   sp
                  }    
                  
    console.log(payload)              
    
    this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})  
     try{

       const res = await api.post(payload)
        
          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }
          
          const data = res.data.recordsets[0][0]
          let msg = 'DOCUMENTO GIA\' ESISTENTE.'
          
          if (Object.keys(data).length === 2) 
          {
            msg = 'NUOVO DOCUMENTO REGISTRATO.'            
          }

          await this.$refs.msgModal.show(msg,{'spinner' : false,'title':'DOCUMENTO DI CONSEGNA'})    
          
          this.$emit('update',res.data.recordsets[0][0].stockMovementId)
          //return res.data.recordsets[0][0].stockMovementId
            
    }
    catch(err){
           
            this.$refs.msgModal.show(err.message)
            //return 0
    }
 




    
      
	},

    
}
    
}    
</script>

<style scoped>
 
.bold {
  font-weight  : bolder;
  
}

h4 {
  color        :rgb(114, 52, 7) ;
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
  font-weight  : bold;
}



</style>